import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { userChangedModalVisibleSelector } from 'src/store/userChangedModal/selectors';

export const userChangedModalSelector = createStructuredSelector({
  visible: userChangedModalVisibleSelector
});

export const userChangedModalPropTypes = {
  visible: PropTypes.bool.isRequired
};
